import {
  withTranslation,
} from 'react-i18next';

import ResultsOverallSectionView from './ResultsOverallSectionView';

const TranslatedComponent = withTranslation()(ResultsOverallSectionView);

const Component = TranslatedComponent;

export default Component;
